import React, { useState } from 'react';

function LayersPanel({ layers, layerVisibility, onLayerToggle }) {
  const [isOpen, setIsOpen] = useState(false);

  // Don't render if no layers available
  if (!layers || layers.length === 0) {
    return null;
  }

  return (
    <div className={`layers-panel ${isOpen ? 'open' : ''}`}>
      {/* Toggle Tab */}
      <button
        className="layers-panel-tab"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-label={isOpen ? 'Close layers panel' : 'Open layers panel'}
      >
        <svg
          className="layers-panel-icon"
          width="18"
          height="18"
          viewBox="0 0 256 256"
          fill="currentColor"
        >
          <path d="M220.54,86.66l-88-48.18a8,8,0,0,0-7.68,0l-88,48.18a8,8,0,0,0,0,14l88,48.18a8,8,0,0,0,7.68,0l88-48.18a8,8,0,0,0,0-14ZM128,133.33,54.08,93.33,128,53.33l73.92,40ZM216.54,155.66l-88,48.18a8,8,0,0,1-7.68,0l-88-48.18a8,8,0,0,1,7.68-14L128,185.33l87.46-41.85a8,8,0,1,1,7.68,14Z"/>
        </svg>
        <span className="layers-panel-label">Layers</span>
        <svg
          className={`layers-panel-chevron ${isOpen ? 'open' : ''}`}
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
        >
          <path
            d="M4.5 3L7.5 6L4.5 9"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {/* Panel Content */}
      <div className="layers-panel-content">
        <div className="layers-panel-header">
          <h3>Map Layers</h3>
        </div>
        <div className="layers-panel-list">
          {layers.map((layer) => (
            <label key={layer.id} className="layers-panel-item">
              <input
                type="checkbox"
                checked={layerVisibility[layer.id] || false}
                onChange={(e) => onLayerToggle(layer.id, e.target.checked)}
              />
              <span className="layers-panel-checkbox">
                <svg viewBox="0 0 12 12" fill="none">
                  <path
                    d="M2.5 6L5 8.5L9.5 4"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <span className="layers-panel-item-label">{layer.label}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
}

export default LayersPanel;

